<template>
  <div class="content">
    <!-- TODO:考试页面HTML -->
    <Card class="main" v-if="showEx" >
      <Row type="flex" >
        <div style="color:#3562E8;margin-bottom:15px;cursor: pointer;display: flex;justify-content: space-between;width: 100%;">
          <div style="color:red"   >特别提醒：请务必填写调查问卷，以便及时查询到学时（学分）！</div>
          <div @click="backNavi">返回</div>
        </div>
        <div class="anwserBox">
          <Row>
            <Col :span="24">
            <div class="titleBox">
              <Row>
                <Col :span="24">
                	<h3 class="backBlk">问卷调查<span class="malft40"></span></h3>
                </Col>
              </Row>
              <div class="content">
                <div class="malft60" v-for="(item,keys) in data" :key="keys">
                    <div v-if="item.questionType == 1">
                        <div class="question">
                            <h3>{{keys+1}}.{{item.question }}</h3>
                        </div>
                        <div>
                            <div style="text-align:left;">
                            <RadioGroup v-model="item.answer">
                                <Radio  v-for="(item, i) in item.options" :key="i" :label="item.name" >
                                {{ item.name }}.{{ item.answer }}
                                </Radio>
                            </RadioGroup>
                            </div>
                        </div>
                    </div>
                    <div class="malft60" v-if="item.questionType == 2">
                        <div class="question">
                            <h3>{{keys+1}}.{{ item.question }}</h3>
                        </div>
                        <div>
                            <div style="text-align:left;">
                            <CheckboxGroup v-model="item.answer">
                                <Checkbox  v-for="(item, i) in item.options" :key="i" :label="item.name" >
                                {{ item.name }}.{{ item.answer }}
                                </Checkbox >
                            </CheckboxGroup>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.questionType == 3">
                        <div class="question">
                            <h3>{{keys+1}}.{{ item.question }}</h3>
                        </div>
                    <div>
                        <div style="text-align:left;">
                        <Input v-model="item.answer" style="width:90%" type="textarea" :rows="9" placeholder="请输入答案" />
                        </div>
                    </div>
                    </div>
                </div>
                <div class="buttonBox">
                  <Button type="primary" style="width:188px;height:52px;background:#3458C4;border:none;margin-left:36px" @click="subTopic">提交</Button>
                </div>
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </Row>
    </Card>
    <!-- TODO：成功页面HTML -->
    <Modal class="success" v-model="showiss" footer-hide>
        <div class="headImg">
            <img src="https://medoss.oss-cn-shanghai.aliyuncs.com/uploads/1622455450739.png" class="img26" />
            <div class="diaTitle">回答结束</div>
            <div class="titleFin">完成用时 <span class="seconds">{{seconds}}秒</span></div>
        </div>
        <div class="flex">
            <div class="cancel" @click="cancel">返回</div>
        </div>
    </Modal>
  </div>
</template>

<script>

import { queryProjectVote, addVoteAnswer } from '@/network/study.js' 

export default {
  name: 'questionnaire',
    data(){
        return{
            hini: false,
            returnExamination: false,
            newTime: null,
            time: 60 * 60 * 1000,
            answerTime: null,
            expenditureTime: null,
            timereset: null,
            showis: false,
            showiss: false,
            answerIs: false,
            result: null,
            voteStatus: null,
            anwser: null,
            residue: null,
            anwsers: [],
            anwserString: '',
            data: [],
            answerSize: null,
            current: 1,
            pageSize: 10,
            noticeArr: [],
            title: '提示',
            message: '问卷未完成，确定要退出吗？',
            rowData:{},
            type: 0,
            topicData: {},
            right: [],
            err: [],
            timeAn: null,
            seconds: 0,
            minutes: null,
            hours: null,
            passAlso: null,
            showEx: true,
            courseIds:{},
        }
    },
    deactivated(){
        this.showis = false;
        this.returnExamination = false;
        if(this.result != 1){
            this.subTopic();
        }
        this.data = [];
        this.$store.commit("setTabBarShow", true);
    },
    destroyed(){
        this.showis = false;
        this.data = [];
        this.showEx = false;
        this.$store.commit("setTabBarShow", true);
    },

    activated(){
        /**
         * 页面初始化  正常考试流程
         */
        this.$store.commit("setTabBarShow", false);
        this.showis = false;
        this.showiss = false;
        this.result = null;
        this.current = 1;
        console.log(this.$route.query);
        if(this.$route.query.id){
            this.queryProjectVote(this.$route.query.id);
            this.CalculateNumber();
        }
    },

    computed:{
    },

    methods:{
        /**
         * 时间重置
         */
        timeReset(){
            if(this.$refs.timeCount){
                this.$refs.timeCount.reset();
            }
        },

        /**
         * 获取项目问卷
         */
        queryProjectVote(data){
            queryProjectVote(data)
            .then(res => {
                console.log(res);
                this.data = res.data.data.questionList;
                this.current = this.data.length+1;
                this.anwArr(this.data)
            })
        },

        /**
         * 重新测试
         */
        returnExaminations(){
            this.$router.go(-1);
        },

        /**
         * 查看试卷
         */
        lookExamination(){

        },

        /**
         * 成功查看试卷
         */
        seeSuccess(){
            this.returnExamination = true;
            this.result = 0;
            this.answerIs = false;
            this.current = 1;
            this.$forceUpdate();
        },
        /**
         * 时间倒计时结束  触发提交试卷接口 并提示考试时间已到
         */
        finishTime(){
            this.$toast('考试时间已到')
            this.subTopic();
        },

        CalculateNumber(){
            this.seconds = 0;
            clearInterval(this.timeAn);
            this.timeAn = setInterval(()=> {
                if(!this.showiss){
                    this.seconds += 1;
                }
            },1000)
        },

        backNavi(){
            if(!this.returnExamination && this.result === null){
                this.$Modal.confirm({
                    title: '提示',
                    content: '问卷未完成，确定要退出吗？',
                    onOk: () => {
                      this.subTopic();
                      this.$router.go(-1)
                    },
                    onCancel: () => {
                    }
                });
            }
            else if(this.result >= 0){
                let ob = this.courseIds;
                ob.projectId = this.topicData.projectId;
                ob.courseId = this.topicData.courseId;
                console.log(ob)
                this.$router.replace({name: 'projectDetails',params:{list:ob}})
            }
            else{
                let ob = this.courseIds;
                ob.projectId = this.topicData.projectId;
                ob.courseId = this.topicData.courseId;
                console.log(ob)
                this.$router.replace({name: 'projectDetails',params:{list:ob}})
            }
        },

        /**
         * 返回首页
         */
        returnHome(){
            this.$router.push('/home');
        },

        /**
         * 返回课程
         */
        returnCourse(){
            this.$router.push({name:'projectDetails'});
        },

        /**
         * 退出考试 提交试卷
         */
        editExamination(){
            endExam({
                courseId: this.topicData.courseId,
                examId: this.topicData.examId,
                projectId: this.topicData.projectId,
                list: []
            })
            .then(res => {
                console.log(res)
                if(res.data.code === 200){
                    this.$toast.success('退出考试成功')
                    this.result = res.data.data.isPass;
                    this.residue = res.data.data.residue;
                    console.log(this.residue,res.data.data.residue)
                    this.$forceUpdate();
                    if(this.result !== 3){
                        this.right = res.data.data.right;
                        this.err = res.data.data.error;
                    }
                    this.newTime = this.getNowFormatDate();
                    this.expenditureTime = this.answerTime - this.time 
                    this.hini = false;
                    this.answerIs = true;
                }
            })
        },

        /**
         * 退出考试 触发提交试卷接口
         */
        confirm(){
            this.$router.go(-1)
        },

        confirms(){
            this.subTopic();
            this.$router.replace('/home')
        },
        cancel(){
            this.showiss = false;
            this.$router.go(-1);
        },

        cancels(){
            this.showis = false;
        },
        
        /**
         * 再异步遍历所有数据 转为数组
        */
        async anwArrs() {
            await this.data.forEach(element => {
                let arr = [];
                for(let i = 0;i<26;i++){
                    let code = 'choice' + String.fromCharCode(65+i);
                    if(element[code] !== null && element[code] !== undefined){
                        let o = {
                            option: element[code],
                            name: String.fromCharCode(65+i)
                        }
                        arr.push(o)
                    }
                }
                element.options = arr;
            });
        },

        /**
         * 查看试卷退出
         */
        subEdit(){
            this.$router.go(-1);
        },

        /**
         * 提交试卷  
         */
        subTopic(){
            let that = this;
            let arr = [];
            this.data.forEach(e => {
                if(e.answer){
                    if(Array.isArray(e.answer)){
                        let obj = {
                            ansewer: e.answer.join(','),
                            questionId: e.id,
                            voteId: e.voteId
                        }
                        arr.push(obj);
                    }
                    else{
                        let obj = {
                            ansewer: e.answer,
                            questionId: e.id,
                            voteId: e.voteId
                        }
                        arr.push(obj);
                    }
                }
            })
            if(arr.length > 0){
              
                addVoteAnswer(arr,this.$route.query.pid)
                .then(res =>{
                    if(res.data.code == 200){
                        that.result = 1;
                        this.showiss = true;
                        clearInterval(this.timeAn);
                    }
                })
            }
        },

        /**
         * 下一步
         */
        nextTopic(){
            if(!this.returnExamination){
                //单选题
                if(this.data[this.current - 1].type === 1){
                    if(this.anwser === null){
                        this.$toast('请选择你的答案')
                        return
                    }
                    saveTopic({
                        courseId: this.topicData.courseId,
                        examId: this.topicData.examId,
                        isValid: this.data[this.current - 1].isValid,
                        projectId: this.topicData.projectId,
                        questionId: this.data[this.current - 1].id,
                        score: this.data[this.current - 1].score,
                        userAnswer: this.anwser,
                    })
                    .then(res => {
                        if(res.data.code === 200){
                            this.data[this.current - 1].userAnswer = this.anwser;
                            this.anwser = null;
                            this.current += 1;
                            this.$forceUpdate();
                        }
                    })
                }
                //多选题
                if(this.data[this.current - 1].type === 2){
                    if(this.anwsers.length < 1){
                        this.$toast('请选择你的答案')
                        return
                    }
                    saveTopic({
                        courseId: this.topicData.courseId,
                        examId: this.topicData.examId,
                        isValid: this.data[this.current - 1].isValid,
                        projectId: this.topicData.projectId,
                        questionId: this.data[this.current - 1].id,
                        score: this.data[this.current - 1].score,
                        userAnswer: this.anwsers.join(','),
                    })
                    .then(res => {
                        if(res.data.code === 200){
                            this.data[this.current - 1].userAnswer = this.anwsers.join(',');
                            this.anwsers = [];
                            this.current += 1;
                            this.$forceUpdate();
                        }
                    })
                }
                //问答题
                if(this.data[this.current - 1].type === 3){
                    if(this.anwserString === ''){
                        this.$toast('请输入你的答案')
                        return
                    }
                    saveTopic({
                        courseId: this.topicData.courseId,
                        examId: this.topicData.examId,
                        isValid: this.data[this.current - 1].isValid,
                        projectId: this.topicData.projectId,
                        questionId: this.data[this.current - 1].id,
                        score: this.data[this.current - 1].score,
                        userAnswer: this.anwserString,
                    })
                    .then(res => {
                        if(res.data.code === 200){
                            this.data[this.current - 1].userAnswer = this.anwserString;
                            this.anwserString = '';
                            this.current += 1;
                            this.$forceUpdate();
                        }
                    })
                }
            }
            else{
                this.current += 1;
                console.log(this.data[this.current - 1]);
                if(this.data[this.current - 1].type === 2){
                    this.data[this.current - 1].answer = this.data[this.current - 1].answer.split(',')
                    this.data[this.current - 1].answer.forEach(l => {
                        this.data[this.current - 1].options.forEach(p => {
                            if(l === p.name){
                                p.isAnswer = 1;
                            }
                        })
                    })
                }
                this.$forceUpdate();
            }
        },
        
        /**
         * 上一步
         */
        onTopic(){
            
            if(!this.returnExamination){
                // 单选题
                if(this.data[this.current - 2].type === 1){
                    this.anwser = this.data[this.current - 2].userAnswer;
                }
                //多选题
                if(this.data[this.current - 2].type === 2){
                    this.anwsers = this.data[this.current - 2].userAnswer.split(',');
                }
                // 问答题
                if(this.data[this.current - 2].type === 3){
                    this.anwserString = this.data[this.current - 2].userAnswer;
                }
                this.current -= 1;
            }
            else{
                this.current -= 1;
                console.log(this.current)
                this.$forceUpdate();
            }
        },

        /**
         * 先遍历第一个data中的数据转为数组
         */
        async anwArr(data){
            let obj = {}
            data.forEach(d =>{
                let arr = [];
                if(d.questionType != 3){
                    let o = d.option.split(',');
                    if(o && o.length > 0){
                        o.forEach(p => {
                            obj = {
                                name: null,
                                answer: null,
                            }
                            let i = p.indexOf('、');
                            let s1 = p.substring(0,i);
                            let s2 = p.substring(i+1);
                            obj.name = s1;
                            obj.answer = s2;
                            arr.push(obj);
                            obj = {
                                name: null,
                                answer: null,
                            }
                        })
                        d.options = arr;
                    }
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  border: none;
  color: #000;
  .main {
    height: 100%;
    .anwserBox {
      width: 100%;
      .titleBox {
        line-height: 48px;
        color: #fff;
        width: 100%;
        .spanImg{
            width: 51px;
            height: 23px;
            line-height: 20px;
            margin-top: 10px;
            position: relative;
            top: 5px;
          }
        .span3 {
          .spanImg{
            width: 51px;
            height: 23px;
            line-height: 20px;
          }
          text-align: center;
          width: 54px;
          height: 23px;
        }
        span {
          font-size: 16px;
          margin: 0;
          color: #fff;
          margin-right: 40px;
        }
      }
      .right {
        height: 1200px;
        background-color: #f8faff;
        padding: 15px 15px 0 80px;
        .submit {
          background: #3562e8;
          width: 246px;
          height: 40px;
          color: #fff;
        }
        .options {
          float: left;
          width: 30px;
          height: 30px;
          user-select: none;
          margin-bottom: 18px;
          border-radius: 4px;
          border: 1px solid #333;
          color: #333;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .multipleBox {
          width: 260px;
          display: flex;
          margin-top: 14px;
          :not(:last-child) {
            margin-right: 20px;
          }
        }
        .singleBox {
          width: 260px;
          display: flex;
          margin-top: 14px;
          flex-wrap: wrap;
          :not(:last-child) {
            margin-right: 20px;
          }
        }
        .optionsActive {
          float: left;
          width: 30px;
          height: 30px;
          user-select: none;
          margin-bottom: 18px;
          border-radius: 4px;
          border: 1px solid #3562e8;
          color: #3562e8;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .userActive{
          float: left;
          width: 30px;
          height: 30px;
          user-select: none;
          margin-bottom: 18px;
          border-radius: 4px;
          border: 1px solid #3562e8;
          color: #3562e8;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .shortBox {
          width: 260px;
          display: flex;
          margin-top: 14px;
          :not(:last-child) {
            margin-right: 20px;
          }
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin-bottom: 24px;
        }
      }
      .content {
        position: relative;
        text-align: center;
        //   display: flex;
        justify-content: center;
        .text {
          display: inline-block;
          word-wrap: break-word;
        }
        .buttonBox {
          width: 100%;
          display: flex;
          justify-content: center;
          margin-top: 20px;
        }
      }
    }
  }
  // TODO:刚开始进入页面的样式
  .create {
    height: 100%;
    padding-top: 150px;
	  padding-bottom: 165px;
    text-align: center;
    .courseInfo {
      margin-top: 60px;
      margin: 0 auto;
      margin: 60px 0 65px 0;
      div {
        font-size: 16px;
        font-weight: 500;
        margin-top: 20px;
      }
    }
  }
  //TODO:成功页面样式
  .success {
    height: 100%;
    padding-top: 60px;
    padding-bottom: 40px;
    text-align: center;
    img {
      width: 247px;
      height: 182px;
      margin: 60px 0 50px 0;
    }
  }
  // TODO:等待批阅页面样式
  .wait {
    height: 100%;
    padding-top: 60px;
    padding-bottom: 40px;
    text-align: center;
    img {
      width: 247px;
      height: 182px;
      margin: 60px 0 30px 0;
    }
  }
  // TODO:失败页面样式
  .error {
    height: 100%;
    padding-top: 60px;
    padding-bottom: 40px;
    text-align: center;
    img {
      width: 247px;
      height: 182px;
      margin: 60px 0 30px 0;
    }
  }
}
/deep/.ivu-radio-group {
  width: 60%;
  margin: 0 auto;
  label {
    display: block;
  }
  .ivu-radio-wrapper{
    white-space: inherit;
	width: 650px;
  }
}
/deep/.ivu-checkbox-group {
  margin: 0 auto;
  label {
    display: block;
  }
  .ivu-radio-wrapper{
    white-space: inherit;
	width: 650px;
  }
}
.answerGreen{
  border: 1px solid #00A21A !important;
    background-color: #fff;
    color: #00A21A !important;
}
.answerRed{
  border: 1px solid #DB1829 !important;
    background-color: #fff;
    color: #DB1829 !important;
}
.answerAffirm{
  color: #00A21A;
  /deep/.ivu-radio::after{
    position: absolute;
    width: 11px;
    height: 11px;
    left: 2.5px;
    top: 3px;
    border-radius: 50%;
    display: table;
    border-top: 0;
    border-left: 0;
    content: ' ';
    background-color: #80C269 !important;
  }
  /deep/.van-checkbox__icon .van-icon{
      background: #00A21A !important;
  }
  /deep/.ivu-checkbox-disabled .ivu-checkbox-inner:after{
    border-color: #00A21A !important;
  }
  /deep/.ivu-checkbox-inner:after{
    content: '';
    display: table;
    width: 0.02083rem;
    height: 0.04167rem;
    position: absolute;
     top: 0.01042rem; 
     left: 0.02604rem; 
     border: 0.01042rem solid #fff; 
     border-top: 0; 
     border-left: 0; 
     -webkit-transform: rotate(
45deg
) scale(1);
    -ms-transform: rotate(45deg) scale(1);
     transform: rotate(
45deg
) scale(1); 
     -webkit-transition: all .2s ease-in-out;
     transition: all .2s ease-in-out;
  }
  /deep/.ivu-checkbox-checked .ivu-checkbox-inner:after{
    content: ' ';
    display: table;
    width: 0.02083rem;
    height: 0.04167rem;
    position: absolute; 
     top: 0.01042rem; 
     left: 0.02604rem; 
    border: 0.01042rem solid red; 
    border-top: 0;
    border-left: 0;
    -webkit-transform: rotate(
    45deg
    ) scale(1);
        -ms-transform: rotate(45deg) scale(1);
        transform: rotate(
    45deg
    ) scale(1);
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }
}
.errDatas{
  /deep/.ivu-radio::after{
    position: absolute;
    width: 11px;
    height: 11px;
    left: 2.5px;
    top: 3px;
    border-radius: 50%;
    display: table;
    border-top: 0;
    border-left: 0;
    content: ' ';
    background-color: #DB1829;
  }
}
/deep/.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after{
  border-color: #3562e8;
}
/deep/.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner{
  border-color: #dcdee2;
}
/deep/.ivu-radio-disabled .ivu-radio-inner{
}
.question{
  text-align: left;
}
.backBlk{
    background-color: #000;
    padding-left: 32px;
    font-weight: bold;
}
.malft40{
    margin-left: 40px !important;
    display: inline-block;
}
.malft60{
    margin-left: 60px;
}

.headImg{
    text-align: center;
    margin-top: 77px;
    margin-bottom: 28px;
}
.diaTitle{
    color: #000000;
    font-size: 36px;
    font-weight: bold;
}
.titleFin{
    font-size: 28px;
    color: #000000;
    margin-bottom: 40px;
    margin-top: 30px;
}
.seconds{
    font-size: 57px;
    color: #5236FF;
    font-weight: bold;
}
.img26{
    width: 157px;
    height: 153px;
}
.flex{
    display: flex;
    justify-content: center;
    margin-bottom: 61px;
    .cancel{
        width: 216px;
        height: 54px;
        line-height: 54px;
        border: 0.5px solid #5236FF;
        background-color: #fff;
        text-align: center;
        border-radius: 10px;
        color: #5236FF;
        margin-right: 21px;
    }
}
</style>